import React, { useEffect, useState } from "react";
import { monthlyAttendanceList } from "../../../api/HostelStudentAttendance";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import HostelHeader from "../HostelHeader";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import { formatToDateInTime } from "../../master/FormatToDateTime";
import { printElement } from "../../master/Print";

export default function HostelStudentAttendanceListMonthly() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [month, setMonth] = useState(() => {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}`;
  });

  const [year, monthNum] = month.split("-").map(Number);
  const daysInMonth = new Date(year, monthNum, 0).getDate();
  const [hostel_id, setHostelId] = useState(localStorage.getItem("hostel_id"));

  const getStaffList = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      if (month) addUrl += `&month=${month}`;
      if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;

      const response = await monthlyAttendanceList(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, [month]);

  // ---- UI-only helpers (no logic/behavior change) ----
  const monthLabel = new Date(year, monthNum - 1, 1).toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  const isWeekendDay = (day) => {
    const d = new Date(year, monthNum - 1, day).getDay();
    return d === 0 || d === 6; // Sun/Sat, styling only
  };

  // Sticky column widths (kept in sync between header <th> and body <td>)
  const COL_HASH_WIDTH = 44;
  const COL_NAME_WIDTH = 200;

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <HostelHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card mb-3 shadow-sm">
                  <div className="card-body">
                    <div className="row g-3 align-items-center">
                      <div className="col">
                        <h4 className="mb-0 d-flex align-items-center gap-2">
                          <i className="bx bx-calendar-check text-primary"></i>
                          Monthly Attendance
                        </h4>
                        <small className="text-muted">{monthLabel}</small>
                      </div>
                      <div className="col-auto text-end d-flex gap-2">
                        <Link
                          to={"/hostel/student/attendance/list"}
                          className="btn btn-label-primary d-inline-flex align-items-center gap-1"
                        >
                          <i className="bx bx-calendar-star"></i>
                          Today Attendance
                        </Link>

                        <button
                          className="btn btn-outline-info d-inline-flex align-items-center gap-1"
                          onClick={() =>
                            printElement(
                              "PrintDiv",
                              `
      @page {
        size: A4 landscape;
        margin: 8mm;
      }

      html,
      body {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      #PrintDiv {
        width: 100% !important;
        max-width: 100% !important;
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }

      #PrintDiv.table-responsive {
        overflow: visible !important;
        max-height: none !important;
      }

      #PrintDiv table {
        width: 100% !important;
        max-width: 100% !important;
        table-layout: fixed !important;
        border-collapse: collapse !important;
        font-size: 7px !important;
      }

      #PrintDiv th,
      #PrintDiv td {
        position: static !important;
        float: none !important;
        box-shadow: none !important;
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        padding: 2px !important;
        vertical-align: middle !important;
      }

      #PrintDiv th:nth-child(1),
      #PrintDiv td:nth-child(1) {
        width: 20px !important;
      }

      #PrintDiv th:nth-child(2),
      #PrintDiv td:nth-child(2) {
        width: 100px !important;
      }

      #PrintDiv th:nth-child(3),
      #PrintDiv td:nth-child(3) {
        width: 65px !important;
      }

      #PrintDiv th:nth-child(4),
      #PrintDiv td:nth-child(4) {
        width: 65px !important;
      }

      #PrintDiv th:nth-child(n+5),
      #PrintDiv td:nth-child(n+5) {
        width: auto !important;
        min-width: 0 !important;
        font-size: 6px !important;
      }

      #PrintDiv small {
        font-size: 5px !important;
        line-height: 1.1 !important;
      }

      #PrintDiv tr {
        page-break-inside: avoid !important;
      }

      #PrintDiv thead {
        display: table-header-group !important;
      }

      #PrintDiv tbody {
        display: table-row-group !important;
      }
      `,
                              1,
                            )
                          }
                        >
                          <i className="bx bx-printer"></i>
                          Print
                        </button>
                      </div>
                    </div>
                    <hr />
                    <div className="row g-2 align-items-center">
                      <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="month"
                            className="form-control"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                          />
                          <label htmlFor="">Select Month</label>
                        </div>
                      </div>
                      <div className="col-auto ms-auto d-flex gap-2">
                        <span className="badge bg-label-secondary d-inline-flex align-items-center gap-1">
                          <span
                            className="d-inline-block rounded-circle bg-danger"
                            style={{ width: 8, height: 8 }}
                          ></span>
                          Absent
                        </span>
                        <span className="badge bg-label-secondary d-inline-flex align-items-center gap-1">
                          <span
                            className="d-inline-block rounded-circle bg-success"
                            style={{ width: 8, height: 8 }}
                          ></span>
                          Present
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card shadow-sm">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">Attendance Grid</h6>
                    <span className="badge bg-label-primary rounded-pill">
                      {data?.length ?? 0} student{data?.length === 1 ? "" : "s"}
                    </span>
                  </div>
                  <div className="card-body p-0">
                    <div
                      className="table-responsive"
                      id="PrintDiv"
                      style={{ maxHeight: "75vh" }}
                    >
                      <table className="table table-bordered table-hover table-sm align-middle mb-0">
                        <thead
                          className="table-light"
                          style={{ position: "sticky", top: 0, zIndex: 2 }}
                        >
                          <tr>
                            <th
                              className="text-center"
                              style={{
                                width: `${COL_HASH_WIDTH}px`,
                                position: "sticky",
                                left: 0,
                                zIndex: 3,
                                background: "inherit",
                              }}
                            >
                              #
                            </th>
                            <th
                              className="text-nowrap"
                              style={{
                                width: `${COL_NAME_WIDTH}px`,
                                position: "sticky",
                                left: `${COL_HASH_WIDTH}px`,
                                zIndex: 3,
                                background: "inherit",
                                boxShadow: "2px 0 2px -1px rgba(0,0,0,0.08)",
                              }}
                            >
                              Name
                            </th>
                            <th className="text-nowrap">Hostel</th>
                            <th className="text-nowrap">Room & Bed No</th>
                            {/* <th>Mobile</th> */}
                            {[...Array(daysInMonth)].map((_, i) => (
                              <th
                                key={i}
                                className={`text-center text-nowrap ${
                                  isWeekendDay(i + 1)
                                    ? "bg-label-secondary"
                                    : ""
                                }`}
                                style={{ minWidth: "56px" }}
                              >
                                {String(i + 1).padStart(2, "0")}
                              </th>
                            ))}
                          </tr>
                        </thead>

                        <tbody>
                          {data?.length > 0
                            ? data.map((item, i) => {
                                return (
                                  <tr key={item.id || i}>
                                    <td
                                      className="text-center text-muted"
                                      style={{
                                        position: "sticky",
                                        left: 0,
                                        background: "inherit",
                                      }}
                                    >
                                      {i + 1}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{
                                        position: "sticky",
                                        left: `${COL_HASH_WIDTH}px`,
                                        background: "inherit",
                                        boxShadow:
                                          "2px 0 2px -1px rgba(0,0,0,0.08)",
                                      }}
                                    >
                                      <span className="fw-medium">
                                        {item.student_name}
                                      </span>{" "}
                                      <small className="text-muted">
                                        ({item.registration_no})
                                      </small>
                                    </td>
                                    <td className="text-nowrap">
                                      {item?.hostel?.name}
                                    </td>
                                    <td className="text-nowrap">
                                      {item?.room?.room_no} ({item?.bed?.bed_no}
                                      )
                                    </td>
                                    {/* <td>{item.mobile}</td> */}

                                    {[...Array(daysInMonth)].map((_, j) => {
                                      const day = String(j + 1).padStart(
                                        2,
                                        "0",
                                      );
                                      const dateStr = `${month}-${day}`;
                                      const currentDate = new Date();
                                      const cellDate = new Date(dateStr);

                                      const attendanceForDate =
                                        item?.attendances?.filter((att) => {
                                          const inDate =
                                            att?.in_datetime?.slice(0, 10);
                                          const outDate =
                                            att?.out_datetime?.slice(0, 10);

                                          return (
                                            inDate === dateStr ||
                                            outDate === dateStr ||
                                            (inDate <= dateStr &&
                                              (!outDate || outDate >= dateStr))
                                          );
                                        });

                                      const isAbsent =
                                        attendanceForDate?.length === 0;

                                      if (cellDate > currentDate) {
                                        return (
                                          <td
                                            key={j}
                                            className={
                                              isWeekendDay(j + 1)
                                                ? "bg-label-secondary"
                                                : ""
                                            }
                                          ></td>
                                        );
                                      }

                                      if (isAbsent) {
                                        return (
                                          <td
                                            key={j}
                                            className={`text-danger fw-semibold text-center ${
                                              isWeekendDay(j + 1)
                                                ? "bg-label-secondary"
                                                : ""
                                            }`}
                                          >
                                            -
                                          </td>
                                        );
                                      }

                                      return (
                                        <td
                                          key={j}
                                          className={
                                            isWeekendDay(j + 1)
                                              ? "bg-label-secondary"
                                              : ""
                                          }
                                        >
                                          {attendanceForDate.map((att, k) => (
                                            <small
                                              key={k}
                                              className="d-block text-nowrap text-success"
                                            >
                                              {formatToDateInTime(
                                                att?.in_datetime,
                                              )}{" "}
                                              -{" "}
                                              {formatToDateInTime(
                                                att?.out_datetime,
                                              )}
                                            </small>
                                          ))}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })
                            : !loading && (
                                <tr>
                                  <td
                                    colSpan={4 + daysInMonth}
                                    className="py-5 text-muted text-center"
                                  >
                                    <i className="bx bx-calendar-x fs-1 d-block mb-2"></i>
                                    No attendance records found for {monthLabel}
                                    .
                                  </td>
                                </tr>
                              )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
